import React, { useContext, useEffect, useRef, useState } from "react";
import ProjectPois from "./ProjectPois";
import { Button } from "react-bootstrap";
import ArrowKeysReact from "arrow-keys-react";
import { ReactComponent as ZoomOut } from "../../assets/icons/zoomout.svg";
import { ReactComponent as Zoom } from "../../assets/icons/zoom.svg";
import { ReactComponent as Right } from "../../assets/icons/right.svg";
import { ReactComponent as Left } from "../../assets/icons/left.svg";
import { ReactComponent as Close } from "../../assets/icons/close.svg";
import { ReactComponent as Expand } from "../../assets/icons/expand.svg";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { AppContext } from "../../context";
import { SCREEN_SIZES } from "../../config/constants";
import {loadCurrentData, loadDataFail} from "../../store/actions";
import {useDispatch} from "react-redux";

const pixelsPerDegree = 5;
let xDown = null;
let dragStartIndex = 0;

export const RotatableBuilding = ({
                                      floorImages,
                                      activeBuilding,
                                      setAppState,
                                      handleFullScreen,
                                      currentHeight,
                                      setCurrentHeight,
                                      currentWidth,
                                      setCurrentWidth,
                                      setHoveredArea,
                                      hoveredArea,
                                      infoArrayIds,
                                      infoArrayIds2,
                                      mode
                                  }) => {

    const state = useContext(AppContext);
    const contentRef = useRef();
    const [dragging, setDragging] = useState(false);
    // const [dragStartIndex, setDragStartIndex] = useState(0);
    const [dragStart, setDragStart] = useState(1);
    const [dimensions, setDimensions] = useState();
    const [isFullScreen, setIsFullScreen] = useState(false);

    const dispatch = useDispatch();


    const {
        activeFloor,
        imageIndex,
        isMenuOpen,
        viewPort,
        appLoading
    } = state;


    useEffect(() => {
        contentRef.current.focus();
        setDragging(dragging);
    }, [imageIndex, isMenuOpen, activeFloor, viewPort]);


    useEffect(() => {
        if (!appLoading) {

            document.addEventListener("mousemove", handleMouseMove);
            document.addEventListener("mouseup", handleMouseUp, false);


            document.getElementById("img-mapper").addEventListener("touchmove", handleTouchMove, false);
            document.getElementById("img-mapper").addEventListener("touchstart", handleTouchStart);
            document.getElementById("img-mapper").addEventListener("touchend", handleTouchEnd);

            window.addEventListener("resize", handleResize, false);

            return () => {
                document.removeEventListener("mousemove", handleMouseMove);
                document.removeEventListener("mouseup", handleMouseUp, false);

                window.removeEventListener("resize", handleResize, false);

                document.getElementById("img-mapper").removeEventListener("touchmove", handleTouchMove, false);
                document.getElementById("img-mapper").removeEventListener("touchstart", handleTouchStart);
                document.getElementById("img-mapper").removeEventListener("touchend", handleTouchEnd);

            };
        }

    }, [dragging, appLoading]);

    const handleResize = () => {
        if ((navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/iPhone/i))) {
            setCurrentHeight(window.innerHeight);
            setCurrentWidth(window.innerWidth);
        }
        if (window.innerWidth > SCREEN_SIZES.tablet[1]) {
            setAppState({ prop: "isMenuOpen", value: false });
        }
        setDimensions({
            width: window.innerWidth,
            height: window.innerHeight
        });
    };

    const handleMouseDown = event => {
        // // event.preventDefault();
        event.persist();
        setDragging(true);
        // setDragStartIndex(imageIndex);
        dragStartIndex = imageIndex;

        setDragStart(event.screenX);
    };

    const handleTouchStart = evt => {
        evt.stopPropagation()
        dragStartIndex = imageIndex;
        xDown = evt.touches[0].clientX;
    };

    const handleMouseMove = event => {
        if (dragging) {
            const numImages = floorImages.length;
            const pixelsPerImage = pixelsPerDegree * (360 / numImages);
            let dx = (event.screenX - dragStart) / pixelsPerImage;
            updateImageIndex(dx);
        }

    };

    const handleTouchMove = evt => {
        setDragging(true)
        const xUp = evt.touches[0].clientX;
        const numImages = floorImages.length;
        const pixelsPerImage = pixelsPerDegree * (360 / numImages);
        let dx = (xDown - xUp) / pixelsPerImage;
        updateImageIndex(dx);
    };

    const handleMouseUp = () => {
        setDragging(false);
    };

    const handleTouchEnd = (evt) => {
        setDragging(false);
        dragStartIndex = imageIndex;
    };
    const updateImageIndex = dx => {
        const numImages = floorImages.length;
        let index = Math.floor(dx) % numImages;
        if (index < 0) {
            index = numImages + index - 1;
        }
        index = (index + dragStartIndex) % numImages;
        if (index !== imageIndex) {
            setAppState({ prop: "imageIndex", value: index });

        }
    };

    const handleArrowsClick = (type) => {
        if (type === "left") {
            if (imageIndex === floorImages.length - 1)
                return setAppState({ prop: "imageIndex", value: 0 });
            setAppState({ prop: "imageIndex", value: imageIndex + 1 });
        } else {
            let currentIMageIndex = imageIndex - 1;
            if (currentIMageIndex < 0)
                return setAppState({ prop: "imageIndex", value: floorImages.length - Math.abs(currentIMageIndex) });
            setAppState({ prop: "imageIndex", value: currentIMageIndex });
        }
    };

    ArrowKeysReact.config({
        left: () => {
            handleArrowsClick("right");
        },
        right: () => {
            handleArrowsClick("left");
        }
    });


    const fullScreen = () => {
        setIsFullScreen(!isFullScreen);

        if (!isFullScreen) {
            handleFullScreen.enter();
        } else {
            handleFullScreen.exit();
        }
    };

    const renderImage = () => {
            return (
                <div ref={contentRef} {...ArrowKeysReact.events} tabIndex="1">
                    {/*<TransformComponent>*/}
                    {!appLoading &&
                        <ProjectPois
                            url={`${process.env.PUBLIC_URL}/floor/Building${viewPort ? viewPort : activeBuilding}/${activeFloor}/${floorImages[imageIndex]}`}
                            currentHeight={currentHeight}
                            currentWidth={currentWidth}
                            dimensions={dimensions}
                            dragging={dragging}
                            setAppState={setAppState}
                            setCurrentHeight={setCurrentHeight}
                            setCurrentWidth={setCurrentWidth}
                            setHoveredArea={setHoveredArea}
                            hoveredArea={hoveredArea}
                            infoArrayIds={infoArrayIds}
                            infoArrayIds2={infoArrayIds2}
                        />
                    }
                    {/*</TransformComponent>*/}
                </div>

            );
        }
    ;
    //
    // return (
    //   <>
    //     <TransformWrapper
    //       panning={{ disabled: true }}
    //       wheel={{ disabled: false, step: 0.03 }}
    //       doubleClick={{ disabled: true }}
    //     >
    //       {({ zoomIn, zoomOut, resetTransform, ...rest }) => {
    return <>
        <div id="rotatable-image" className="rotatable-image" onMouseDown={handleMouseDown}
             style={{ height: currentHeight, width: currentWidth }}>

            {renderImage()}
        </div>
        <div className="rotatable-buttons">
            <div className="tools">
                {/*<Button variant="link" data-tip data-for="dash"*/}
                {/*        onClick={() => zoomOut()}><ZoomOut /></Button>*/}
                {/*<Button variant="link" data-tip data-for="plus"*/}
                {/*        onClick={() => zoomIn()}><Zoom /></Button>*/}
                <Button variant="link" onClick={() => handleArrowsClick("left")}
                        data-tip data-for="left"
                >
                    <Left /></Button>
                <Button variant="link" onClick={() => handleArrowsClick("right")}
                        data-tip data-for="right">
                    <Right />
                </Button>
                <Button variant="link" data-tip data-for="reset"
                        onClick={() => {
                            setAppState({ prop: "imageIndex", value: 0 });
                            // resetTransform();
                        }}><Close /></Button>

                {!mode && <Button variant="link" onClick={fullScreen}
                                  data-tip data-for="right">
                    <Expand />
                </Button>}
            </div>
        </div>
    </>
    //   }}
    // </TransformWrapper>
    // </>
    // );
};
